import React from 'react';
import TwoFactorSettings from '../TwoFactorSettings';
import PushNotificationSettings from '../PushNotificationSettings';
import { ChangePasswordCard } from '../ChangePasswordCard';
import { AccountPrivacyCard } from '../AccountPrivacyCard';
import TelegramLinkCard from '../TelegramLinkCard';

export default function SecurityTab() {
  return (
    <div className="space-y-6">
      <ChangePasswordCard />
      <AccountPrivacyCard />
      <div className="bg-white rounded-xl shadow-md p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Security Settings</h2>
        <TwoFactorSettings />
      </div>
      <div className="bg-white rounded-xl shadow-md p-6">
        <PushNotificationSettings />
      </div>
      <TelegramLinkCard />
    </div>
  );
}
